<template>
  <div v-if="sampling_detail">
    <p v-if="qualityAttributeIsContinous(quality_attribute) || qualityAttributeIsString(quality_attribute)">
      {{ sampling_detail?.value }}
    </p>
    <p v-else-if="qualityAttributeIsBoolean(quality_attribute)">
      <bool-icon v-if="sampling_detail?.value_bool" />
    </p>
  </div>
</template>

<script>
import QualityAttributeMixin from "@/components/views/mixins/models/quality_attribute.js";
import BoolIcon from "@/components/views/layout/quality_control/BoolIcon.vue";

export default {
  mixins: [QualityAttributeMixin],
  components: { BoolIcon },
  props: {
    quality_attribute: { type: Object, required: true },
    sampling_detail: { type: Object },
  },
};
</script>
